export { isFunction, isBrowser, isInShape } from './checks';
export { viewportHoc } from './viewportHoc';
